import routes from "../../utils/constants/apiRoutes";
import { createSlice, Dispatch } from '@reduxjs/toolkit'
import axios from "../../utils/axios";
import { searchParams } from "src/@types/data";

export function fetchAllRoles(orgCode?: string) {
    return async function getRoles() {
        try {
            const response = await axios.get(orgCode ? `${orgCode}${routes.ROLES}` : `${routes.ROLES}`);
            return response?.data;
        } catch (e) {
            console.log("error while fetchroles", e);
        }
    };
}

